/** Course enrollment status - must match valid values in backend (`Dtos/CourseEnrollementStatusDtoTypes.cs`) */
export const CourseEnrollmentStatus = {
  Open: "åpent for påmelding",
  Full: "fullt",
  Canceled: "kansellert",
} as const;
